export const timeZoneOptions = [
  // United States & Canada
  { value: "America/New_York", label: "Eastern Time (US & Canada)" },
  { value: "America/Chicago", label: "Central Time (US & Canada)" },
  { value: "America/Denver", label: "Mountain Time (US & Canada)" },
  { value: "America/Phoenix", label: "Arizona (No DST)" },
  { value: "America/Los_Angeles", label: "Pacific Time (US & Canada)" },
  { value: "America/Anchorage", label: "Alaska Time" },
  { value: "Pacific/Honolulu", label: "Hawaii Time" },

  // U.S. Territories
  { value: "America/Puerto_Rico", label: "Atlantic Time (Puerto Rico)" },
  { value: "America/St_Thomas", label: "Atlantic Time (U.S. Virgin Islands)" },
  { value: "Pacific/Guam", label: "Chamorro Time (Guam)" },
  { value: "Pacific/Pago_Pago", label: "Samoa Time (American Samoa)" },

  // Europe
  { value: "Europe/London", label: "London (UK)" },
  { value: "Europe/Dublin", label: "Ireland (Dublin)" },
  { value: "Europe/Paris", label: "Central European Time (France, Germany)" },
  { value: "Europe/Berlin", label: "Berlin (Germany)" },
  { value: "Europe/Madrid", label: "Madrid (Spain)" },
  { value: "Europe/Istanbul", label: "Istanbul (Turkey)" },
  { value: "Europe/Moscow", label: "Moscow (Russia)" },

  // Africa
  { value: "Africa/Lagos", label: "West Africa Time (Nigeria)" },
  { value: "Africa/Cairo", label: "Eastern European Time (Egypt)" },
  { value: "Africa/Nairobi", label: "East Africa Time (Kenya)" },
  { value: "Africa/Johannesburg", label: "South Africa Standard Time" },

  // Asia
  { value: "Asia/Karachi", label: "Pakistan Standard Time (PKT)" },
  { value: "Asia/Kolkata", label: "India Standard Time (IST)" },
  { value: "Asia/Dhaka", label: "Bangladesh Standard Time (BST)" },
  { value: "Asia/Shanghai", label: "China Standard Time (CST)" },
  { value: "Asia/Hong_Kong", label: "Hong Kong Time" },
  { value: "Asia/Singapore", label: "Singapore Standard Time" },
  { value: "Asia/Tokyo", label: "Japan Standard Time (JST)" },
  { value: "Asia/Seoul", label: "Korea Standard Time (KST)" },

  // Australia & New Zealand
  { value: "Australia/Sydney", label: "AET (Sydney/Melbourne)" },
  { value: "Australia/Hobart", label: "AET (Hobart)" },
  { value: "Australia/Brisbane", label: "AET (Brisbane, no DST)" },
  { value: "Australia/Adelaide", label: "ACST (Adelaide)" },
  { value: "Australia/Darwin", label: "ACST (Darwin, no DST)" },
  { value: "Australia/Perth", label: "AWST (Perth)" },
  { value: "Pacific/Auckland", label: "New Zealand (Auckland)" },
  { value: "Pacific/Chatham", label: "New Zealand (Chatham, +45m)" },

  // Americas (other)
  { value: "America/Bogota", label: "Colombia Time" },
  { value: "America/Sao_Paulo", label: "Brazil Standard Time" },
  { value: "America/Argentina/Buenos_Aires", label: "Argentina Time" },

  // Universal
  { value: "Etc/UTC", label: "UTC (Coordinated Universal Time)" },
];
